import type { Action, Reducer } from "@reduxjs/toolkit";
import { TracingState, TracingActionTypes, ADD_TRACE_EVENT } from "./types";

const initialState: TracingState = {
    traces: []
}

export const tracingReducer: Reducer<TracingState, Action, TracingState> = (
    state = initialState,
    action: TracingActionTypes
): TracingState => {
    switch (action.type) {
        case ADD_TRACE_EVENT:
            return {
                traces: [action.trace, ...state.traces].slice(0, 100) // Only keep 100 entries...
            };

        default:
            return state;
    }
}